<template>
    <div>
        <table class="authorization-table" border="0" cellspacing='0' cellpadding='0'>
            <thead>
                <tr>
                    <th style='width:53px;'>勾选</th>
                    <th style='width:370px;'>课程</th>
                    <th style='width:97px;'>时长(分钟)</th>
                    <th style='width:87px;'>课程难度</th>
                    <th style='width:80px;'>价格(元)</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="group in tableGroup">
                    <tr :class="{hover: group._hover, group_last: index == getGroupData(group.courseType).length - 1}" @click="click(item,index)" v-for="(item, index) in getGroupData(group.courseType)" @mouseenter="mouseenter(item)" @mouseleave="mouseleave(item)">
                        <td style="border-right: 0;border-bottom: 0;padding-left: 21px;" class="choose_td" :rowspan="getGroupData(group.courseType).length" v-if="index == 0">
                            <div class="select" :class="{active: group._selected,disabled: group._disabled}"></div>
                        </td>
                        <td>
                            {{item.productName}}
                        </td>
                        <td style="text-align: center;">
                            {{item.duration}}’
                        </td>
                        <td style="text-align: center;">
                            <template v-for="item in new Array(item.difficulty)">★</template>
                        </td>
                        <td class="price_td" :rowspan="getGroupData(group.courseType).length" v-if="index == 0" style="border-right: 0;border-bottom: 0;text-align: center;">
                            +{{getGroupPrice(group.courseType)}}
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>
<script>
    // @ is an alias to /src
    import wh from '@/assets/js/wh.js'
    export default {
        name: 'authtable',
        model: {
            prop: 'score',
            event: 'change'
        },
        props: {
            authData: {
                type: Array,
                default: []
            },
            score: {
                type: Object,
                default: () => ({
                    score:0,
                    price: 0
                })
            }
        },
        data: () => ({
            tableData: [],
            tableGroup: []
        }),
        methods: {
            mouseenter (item) {
                let index = this.tableGroup.findIndex(v => v.courseType == item.courseType)
                this.$set(this.tableGroup[index], '_hover', true)
            },
            mouseleave (item) {
                let index = this.tableGroup.findIndex(v => v.courseType == item.courseType)
                this.$set(this.tableGroup[index], '_hover', false)
            },
            async click(item) {
                let index = this.tableGroup.findIndex(v => v.courseType == item.courseType)
                this.$set(this.tableGroup[index], '_selected', !this.tableGroup[index]._selected)
                this.tableData.forEach(v => {
                    if (v.courseType == item.courseType) {
                        this.$set(v, '_selected', this.tableGroup[index]._selected)
                    }
                })
                this.$nextTick(() => {
                    this.$emit('change',{
                        score: this.totalScore,
                        price: this.totalPrice
                    })
                })
            },
            cancelEach (call) {
                //取消所有选中或者禁用的状态，暴露于外部使用
                this.tableData.forEach(v=>{
                    if(call && call(v)) {
                        if(v._exist) return
                        this.$set(v,'_selected',false)
                        this.$set(v,'_ismajor',null)
                    }
                })
                this.$nextTick(() => {
                    this.$emit('change',this.totalScore)
                })
            },
            setDisableEach (call) {
                this.tableData.forEach(v=>{
                    if(v._exist) return
                    this.$set(v,'_disabled',call && call(v))
                })
            },
            getSelections () {
                let selections = []
                this.tableData.forEach(v=>{
                    if (v._selected) {
                        selections.push(v)
                    }
                })
                return selections
            },
            choose (item,index) {
                this.$emit('choose',this.click, item, index)
            },
            getGroupData (type) {
                return this.tableData.filter(v => v.courseType == type)
            },
            getGroupPrice (type) {
                let data = this.getGroupData(type)
                let price = 0
                data.forEach(v => {
                    price += Number(v.price)
                })
                return price
            },
            selectByIds (ids) {
                this.tableData.forEach(v => {
                    if (ids.includes(v.id + '')) {
                        let index = this.tableGroup.findIndex(el => v.courseType == el.courseType)
                        this.$set(this.tableGroup[index], '_selected', true)
                        this.$set(v, '_selected', true)
                    } else {
                        let index = this.tableGroup.findIndex(el => v.courseType == el.courseType)
                        console.log(index)
                        this.$set(this.tableGroup[index], '_selected', false)
                        this.$set(v, '_selected', false)
                    }
                })
            }
        },
        computed: {
            totalScore() {
                var price = 0;
                this.tableData.forEach((v, i) => {
                    if (v._selected) {
                        price += v.integral
                    }
                })
                return price;
            },
            totalPrice() {
                var price = 0;
                this.tableData.forEach((v, i) => {
                    if (v._selected) {
                        price += Number(v.price)
                    }
                })
                return price;
            },
            unit () {
                if (this.isMonth) {
                    return '元/账号/月'
                } else if (this.isQuarter) {
                    return '元/账号/季'
                } else {
                    return '元/账号/年'
                }
            },
            selectIds () {
                return this.tableData.filter(v=>v._selected).map(v=>v.id).join(',')
            },
        },
        watch: {
            authData: {
                handler(val) {
                    if (val.length <= 0) return
                    this.tableData = val.map(v => {
                        let obj = {
                            ...v,
                            _id: wh.randomId(),
                            _selected: true
                        }
                        
                        return obj
                    })
                    let table_group = []
                    val.forEach(v => {
                        if (!table_group.some(el => el.courseType == v.courseType)) {
                            table_group.push({
                                courseType: v.courseType,
                                _selected: true,
                                _id: wh.randomId(),
                                _hover: false
                            })
                        }
                    })
                    this.tableGroup = table_group
                    this.$nextTick(() => {
                        this.$emit('change',{
                            score: this.totalScore,
                            price: this.totalPrice
                        })
                    })
                },
                immediate: true,
                deep: true
            },
            totalScore (val) {
                this.$emit('change',{
                    score: this.totalScore,
                    price: this.totalPrice
                })
            }
        },
        mounted() {
        }
    }
</script>
<style scoped>
    .authorization-table {
        border: 1px solid rgb(186, 190, 193);
        border-collapse: collapse;
        text-align: left;
        font-size: 12px;
        color: #525252;
        background: white;
    }
    
    .authorization-table tr.hover {
        background-color: rgb(233, 241, 253);
    }
    .authorization-table th {
        background: #ffeacb;
        color: rgb(101, 105, 108);
        font-size: 14px;
        height: 24px;
        padding:5px 2px;
        font-weight: normal;
        text-align: center;
        border-right:1px solid #f1cf9b;
    }
    .authorization-table h5,
    .authorization-list table p {
        margin: 0;
        padding: 0;
    }
    .authorization-table th h5 {
        font-size: 13px;
    }
    .authorization-table th p {
        font-size: 12px;
        font-weight: normal;
    }
    .authorization-table td {
        text-align: left;
        border-bottom: 1px solid #f2f5f8;
        border-right: 1px solid #f2f5f8;
        height: 24px;
        padding: 2px 5px;
        color: #525252;
        font-size: 14px;
    }
    .authorization-table .group_last td {
        border-bottom: 1px solid #e1e1e1;
    }
    /* .authorization-table tr td:first-child {
        border-right: 0;
        border-bottom: 0;
    } */
    .authorization-table td i.tips{
        display: inline-block;
        width: 12px;
        height: 12px;
        background: url(../../assets/image/zhuyi.png) no-repeat center;
        position: relative;
        margin-left: 3px;
    }
    .authorization-table td i.tips .tips_content {
        display: none;
        position: absolute;
        top: 15px;
        left: -46px;
        font-style: normal;
        width: 200px;
        text-align: left;
        border: 1px dashed #aba1ce;
        background: #fffdec;
        z-index: 10;
        padding: 10px 1px 10px 10px;
    }
    .authorization-table td i.tips:hover .tips_content {
        display: block;
    }
    /* .authorization-table tr td:last-child {
        border-right: 0;
    } */
    .authorization-table tr:last-child  td{
        border-bottom: 0;
    }
    .authorization-table td .price {
        font-size: 12px;
        color: rgb(189, 189, 189);
    }
    .authorization-table td .price.major_active {
        font-weight: normal;
        font-size: 12px;
        color: #78363A;
    }
    .authorization-table td.pop {
        color: #1261D2;
        position: relative;
    }
    .authorization-table td .pop_wraper {
        display: none;
        width: 427px !important;
        text-align: left !important;
        padding: 15px 15px 15px 20px;
        border: 1px dashed #aba1ce;
        background: #fffdec;
        position: absolute;
        left: -410px;
        z-index: 10;
        color: #525252;
        /* display: none; */
        top: 35px;
    }
    .authorization-table td.pop:hover .pop_wraper {
        display: block;
    }
    .authorization-table td .pop_wraper::before {
        content: '';
        position: absolute;
        right: 6px;
        top: -10px;
        border-bottom: 10px solid #73a3e8;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
    }
    .authorization-table td .select {
        width: 13px;
        height: 13px;
        display: inline-block;
        border-radius: 100%;
        border: 1px solid rgb(173, 173, 165);
    }
    .authorization-table td .select.active {
        background: rgb(242, 153, 1) url(../../assets/image/dui-bai.png) no-repeat center;
        border-color: rgb(242, 153, 1);
    }
    
    .authorization-table td .select.disabled {
        background: rgb(228, 228, 228);
    }
    .authorization-table td .exist.disabled {
        background: rgb(255, 208, 129) url(../../assets/image/dui-bai.png) no-repeat center;
        border-color: rgb(255, 208, 129);
    }
    .authorization-table td.price_td {
        position: relative;
        color: #78363A;
    }
    .authorization-table td.price_td::after {
        content: '';
        position: absolute;
        width: 95%;
        height: 1px;
        bottom: 0;
        left: 0;
        background-color: #e1e1e1;
    }
    .authorization-table td.choose_td {
        position: relative;
    }
    .authorization-table td.choose_td::after {
        content: '';
        position: absolute;
        width: 80%;
        height: 1px;
        bottom: 0;
        right: 0;
        background-color: #e1e1e1;
    }
</style>>